import * as bootstrap from 'bootstrap'

document.addEventListener("DOMContentLoaded", function(event) {
    const modals = document.querySelectorAll('.modal.achievement');

    if (modals) {
        modals.forEach(modal => {
            //Generate modal object
            const myModal = new bootstrap.Modal(modal, {
                keyboard: false
            })

            //Open modal
            myModal.toggle();

            //Share achievement
            modal.querySelector('.btn-primary').addEventListener("click", (e) => {
                //TODO: capire come gestire il social share
                console.log('share');
            });

            //Dismiss achievement
            modal.addEventListener('hidden.bs.modal', event => {
                // Set the achievement as seen
            })
        });
    }
});
